import { GetTrendsParams } from "../../app/api/trends";
import store from "../../app/store";
import { keysToRemoveForGraphAnalysis } from "../../constants/constants";
import { removeKeysFromObject } from "../commonUtils";

export const getTrendFiltersFromSession = (): GetTrendsParams | null => {
  try {
    const sessionStorageData = sessionStorage.getItem("trends");
    if (!sessionStorageData) return null;

    const trendFilters: GetTrendsParams = JSON.parse(sessionStorageData);

    return trendFilters;
  } catch (error) {
    console.error("Error parsing trend filters from sessionStorage", error);
    return null;
  }
};

const normalizeHexColor = (color: string): string =>
  color.startsWith("#") ? color : `#${color}`;

/** L2 colour from session (after Run Analysis) or Redux pending (before Run Analysis). */
export const getStoredColorForLevel2 = (): string => {
  const trendFilters = getTrendFiltersFromSession();
  if (trendFilters?.level2Color) {
    return normalizeHexColor(trendFilters.level2Color);
  }
  if (
    trendFilters?.color_analysis_level === "LEVEL2" &&
    trendFilters?.selected_color
  ) {
    return normalizeHexColor(trendFilters.selected_color);
  }

  const pending = store.getState().trends.pendingColorForLevel2;
  if (pending) {
    return normalizeHexColor(pending);
  }
  return "";
};

export const getTrendFiltersForGraphs = () => {
  const trendFilters = getTrendFiltersFromSession();
  if (!trendFilters) return null;
  removeKeysFromObject(trendFilters, keysToRemoveForGraphAnalysis);
  return trendFilters;
};

/** Trend-curve filters: keep color analysis fields, drop trends-pagination/cache keys. */
export const getTrendFiltersForTrendCurve = () => {
  const trendFilters = getTrendFiltersFromSession();
  if (!trendFilters) return null;
  removeKeysFromObject(trendFilters, [
    "page",
    "pageSize",
    "posts_per_trend",
    "colorAnalysis",
    "level2Color",
    "generic",
    "colors",
  ]);
  return trendFilters;
};

/** Session trend-curve filters merged with a pending L1 colour pick (not yet Run Analysis). */
export const getEffectiveTrendCurveFilters = (): GetTrendsParams | null => {
  const trendFilters = getTrendFiltersForTrendCurve();
  if (!trendFilters) return null;

  const pending = store.getState().trends.pendingColorForLevel2;
  if (pending === null) return trendFilters;

  const effective = { ...trendFilters };
  if (pending) {
    const normalized = pending.startsWith("#") ? pending : `#${pending}`;
    effective.color_analysis_level = "LEVEL2";
    effective.selected_color = normalized.split("#")[1];
  } else {
    effective.color_analysis_level = "LEVEL1";
    delete effective.selected_color;
  }
  return effective;
};

export const getActiveTrendReqId = (): string | undefined => {
  const reduxReqId = store.getState().trends.trendsData?.req_id;
  if (reduxReqId) return reduxReqId;
  return getTrendFiltersFromSession()?.req_id;
};
